module.exports = __webpack_public_path__ + "static/media/valelobo.21f256b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/assets/valelobo.png
// module id = 548
// module chunks = 0